import React from "react";
import "./Highpoints.css";
import hpImg1 from "../../assets/imgs/hpImg1.png";
import hpImg2 from "../../assets/imgs/hpImg2.png";
import hpImg3 from "../../assets/imgs/hpImg3.png";
import hpImg4 from "../../assets/imgs/hpImg4.png";

export default function Highpoints() {
  return (
    <div className="higPnts" id="highpoints">
      <div className="maxW">
        <div className="higMn">
          <h2>Highpoints</h2>
          <p>
            Investment Potential Arvind Smart Spaces Plots Vadodara — Investment
            Potential in Plotted Community
          </p>

          <div className="poinMn">
            <div className="pntBx">
              <img src={hpImg1} alt="icon" />
              <h4>98 Acres Gated complex with advanced security</h4>
            </div>
            <div className="pntBx">
              <img src={hpImg2} alt="icon" />
              <h4>Infrastructure Push Premium Residential Plots</h4>
            </div>
            <div className="pntBx">
              <img src={hpImg3} alt="icon" />
              <h4>Well planned roads & thematic tree-lined avenues</h4>
            </div>
            <div className="pntBx">
              <img src={hpImg4} alt="icon" />
              <h4>Arvind Plots Vadodara Location Advantage</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
